import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a2e073b6ab4c98a98392e68d02b24e484b from "./generated-43f5bb89-fc71-4c3f-9cf2-944761608bee.json";

import ad7fdc3447bd2cfdd496e91a6ceee8a5eb from "./generated-5d1dd9c6-1e24-4d13-9fbc-a3f0a23ef542.json";

import aa3bdf90ce7803003956d39db2c36124db from "./generated-a25489bf-d6bb-4bf9-8700-b987f82c65a6.json";

import ab1256f61f170f3e44510af21b6561ba4b from "./generated-d40450ac-cea1-42ba-8d23-d3db77cafe54.json";

import a8da33817e23d1de305fd61f28010d95fb from "./generated-a9b0e934-6668-46fa-b5f8-1411e8bfcba8.json";

import af3e2ac044cf87255dcbccb446323a6bbb from "./generated-6678141b-2d78-45d3-84f2-a521b02d04c0.json";

import a21a17d33f3b0d4b0a7665779ee82c981b from "./generated-e3d053b0-1c8a-4b2b-9d91-54075dd53a1e.json";

import a60c6ac3543cbd68f53384d669325cd18b from "./generated-2a5ff2b6-5715-4bd3-a926-88d1b6de9822.json";

import a7aec8f1e8b3288f455ea157c5d2b8d48b from "./generated-f475b6e4-5125-44af-8e97-812829b39bad.json";

import a04cff8f22c764201bb0df33f60613036b from "./generated-f7497816-a6bc-41d9-b500-26d052763906.json";

import a85eb084557cf1a6a9e72a91e1337d13fb from "./generated-4386da31-377e-490b-9fd8-423fe014286c.json";

import a665031783fd706bd2e56c9ce3221ebb8b from "./generated-2956697c-32e7-48ba-9fd0-3346e71d418b.json";

import a3608624d0e33a195aa5e261b4d1ee000b from "./generated-4b9ca97b-8e4e-434e-a68b-784e92d8a5f1.json";

import a46a65ed424acfbb8d50dd2ec524ac13ab from "./generated-a1e3e0c4-d6ac-48d8-a98b-cf19ab17d23d.json";

import aa843654e2bff3a83ae06ee7b882ffdcfb from "./generated-17c0ce4c-e3d8-4b7b-92bf-9c31c7eb225c.json";

import a5c060941d74eb07f738a8e2bb4eca409b from "./generated-83df4a57-3476-45ce-814c-f71bed49fada.json";

import ab3f6dded4120247e54ecd39c364bde88b from "./generated-e4b53b34-90b3-4f92-b6db-68d603c59bcd.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a2e073b6ab4c98a98392e68d02b24e484b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ad7fdc3447bd2cfdd496e91a6ceee8a5eb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(aa3bdf90ce7803003956d39db2c36124db);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ab1256f61f170f3e44510af21b6561ba4b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a8da33817e23d1de305fd61f28010d95fb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(af3e2ac044cf87255dcbccb446323a6bbb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a21a17d33f3b0d4b0a7665779ee82c981b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a60c6ac3543cbd68f53384d669325cd18b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a7aec8f1e8b3288f455ea157c5d2b8d48b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a04cff8f22c764201bb0df33f60613036b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a85eb084557cf1a6a9e72a91e1337d13fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a665031783fd706bd2e56c9ce3221ebb8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a7aec8f1e8b3288f455ea157c5d2b8d48b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a3608624d0e33a195aa5e261b4d1ee000b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a46a65ed424acfbb8d50dd2ec524ac13ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a7aec8f1e8b3288f455ea157c5d2b8d48b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(aa843654e2bff3a83ae06ee7b882ffdcfb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a5c060941d74eb07f738a8e2bb4eca409b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ab3f6dded4120247e54ecd39c364bde88b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(aa843654e2bff3a83ae06ee7b882ffdcfb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */